// extracted by mini-css-extract-plugin
export default {"dateInputWrapper":"FormattedDateInput_dateInputWrapper__Ufkzm","dateInput":"FormattedDateInput_dateInput__B7VVr","formattedOverlay":"FormattedDateInput_formattedOverlay__15zx8"};